import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M16.7989 16.8764C16.1396 16.8764 15.6002 16.334 15.6002 15.6712C15.6002 15.0083 16.1396 14.4659 16.7989 14.4659H17.8658C22.9724 14.4659 22.6007 7.07788 17.8777 7.24661C16.2594 -0.804306 3.85259 2.1003 6.29801 10.1753C3.80464 8.1867 0.819779 12.0434 3.36109 13.9356C5.15919 15.2855 8.40775 13.4415 8.40775 15.6712C8.40775 17.1897 6.69358 16.8764 5.05131 16.8764C1.04754 16.8764 -1.40987 12.5858 0.879706 9.30756C1.97055 7.74076 3.68474 7.35509 3.68474 7.35509C4.4759 1.19638 11.4765 -2.05774 16.655 1.42536C18.8847 2.91984 19.7238 5.11337 19.7238 5.11337C21.0304 5.5111 22.1572 6.34269 22.9124 7.43945C25.4897 11.1274 23.4998 16.8764 16.7989 16.8764ZM12.0519 7.23456H12.0639H12.0759H12.0519ZM16.7989 18.5758C16.7989 18.1057 15.5762 18.1057 15.1087 18.5758L14.2336 19.4556C13.85 19.8292 13.2147 19.564 13.2147 19.0337V8.43979C13.2147 7.77692 12.7352 7.24662 12.0759 7.23456C11.4166 7.24662 10.8172 7.77692 10.8172 8.43979V19.0337C10.8172 19.5761 10.1699 19.8412 9.79829 19.4556L8.9232 18.3226C8.45569 17.8526 7.71248 18.0696 7.24498 18.0696H7.23302C6.76551 19.2748 6.76551 19.552 7.23302 20.022L10.3257 23.2641C11.2607 24.2042 12.7831 24.2644 13.7181 23.3244L16.8229 20.239C17.2664 19.781 16.7989 19.0337 16.7989 18.5758Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
